import React from 'react'

import { useFormattedCurrentDateParts } from '@/components/Event/NewScript/hooks/useFormattedCurrentDateParts'
import { Event } from '@/types'
import { getEventTimezone } from '@/utils/time'

type QuestioningVerbatimProps = {
  event: Event
}

export const QuestioningVerbatim: React.FC<QuestioningVerbatimProps> = ({
  event,
}) => {
  const { formattedTimeWithTimezone } = useFormattedCurrentDateParts(
    getEventTimezone(event),
  )

  return (
    <>We are now ON the record and the time is {formattedTimeWithTimezone}</>
  )
}
